import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";

import { enum_api_uri } from "common/hooks/utils/enum";
import { useAuthStore } from "user/store/useAuthStore";

interface LoginRequest {
    m_category: number;
    m_mobile: string;
    m_password: string;
}

interface LoginResponse {
    data: {
        accessToken: string;
        refreshToken: string;
        m_email: string;
        m_mobile: string;
        m_id: string;
        m_level: number;
        m_name: string;
        member_idx: number;
        customer_idx: number;
        m_category: number;
    };
}

export const usePostLogin = (successCallback?: () => void): UseMutationResult<LoginResponse, Error, LoginRequest, unknown> => {
    const setAuth = useAuthStore(state => state.setAuth);

    return useMutation<LoginResponse, Error, LoginRequest>({
        mutationFn: async ({ m_category, m_mobile, m_password }: LoginRequest) => {
            const response = await axios.post(enum_api_uri.user.login, {
                m_category,
                m_mobile,
                m_password,
            });
            return response.data;
        },
        onSuccess: data => {
            const userData = data.data;

            setAuth({
                accessToken: userData.accessToken,
                refreshToken: userData.refreshToken,
                m_email: userData.m_email,
                m_mobile: userData.m_mobile,
                m_id: userData.m_id,
                m_level: userData.m_level,
                m_name: userData.m_name,
                member_idx: userData.member_idx,
                customer_idx: userData.customer_idx,
                m_category: userData.m_category,
            });
            successCallback?.();
        },
        // onError: (error: Error) => {
        //     console.error("로그인 실패:", error);
        // },
        // isError로 수정해보기
    });
};
